export default "__VITE_ASSET__9002012f__"